import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import mapboxgl from 'mapbox-gl';

/**
 * Renders a React component into a Mapbox popup.
 * Creates a container, renders the component using ReactDOM, and returns the popup.
 * Cleans up the React root when the popup is closed.
 */
export const renderPopup = (
  component: React.ReactElement,
  options?: mapboxgl.PopupOptions
): mapboxgl.Popup => {
  const container = document.createElement('div');
  let root: Root | null = null;

  const popup = new mapboxgl.Popup(options).on('open', () => {
    // Render the React component when popup opens
    root = createRoot(container);
    root.render(component);
    popup.setDOMContent(container);
  });

  // Clean up React root when popup closes
  popup.on('close', () => {
    if (root) {
      setTimeout(() => {
        root?.unmount();
        root = null;
      }, 0);
    }
  });

  return popup;
};
